//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "ScheduleCalendarMobileItem",
  components: {
    Button: () => import("@/components/common/Button"),
  },
  props: {
    time: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    items_remain: {
      type: Number,
      default: () => 0,
    },
    price: {
      type: String,
      default: () => '',
    },
    status: {
      type: String,
      default: () => '',
    }
  },
  computed: {
    ...mapGetters({
      bookingTerms: 'schedule-calendar/bookingTerms',
      cancellationTerms: 'schedule-calendar/cancellationTerms',
      context: 'schedule-calendar/context',
      smRegistered: 'schedule-calendar/smRegistered',
      agency: 'schedule-calendar/agency',
      entity: 'schedule-calendar/entity',
      entityTitle: 'schedule-calendar/title',
      currentDay: 'schedule-calendar/currentDay',
      id: 'schedule-calendar/id',
      logged: 'user/logged',
    }),
    buttonText() {
      return this.status === 'available' ?
        this.$t('components.schedule-calendar.item.buy') :
        this.$t('components.schedule-calendar.item.to-order')
    },
  },
  methods: {
    openPopup() {
      const tariffs = this.context.filter(tariff => tariff.time === this.time)
        .filter(tariff => tariff.status === this.status)
      if (this.logged) {
        this.$openPopupOrder({
          bookingTerms: this.bookingTerms,
          cancellationTerms: this.cancellationTerms,
          time: this.time,
          status: this.status,
          tariffs,
          smRegistered: this.smRegistered,
          agency: {
            fullName: this.agency?.legal_information?.fullName,
            inn: this.agency?.legal_information?.inn,
            ogrn: this.agency?.legal_information?.ogrn,
            sm_registered: this.agency?.sm_registered,
          },
          entity: this.entity,
          date: this.currentDay,
          title: this.entityTitle,
          id: this.id,
        })
      } else {
        this.$cookies.set('$openPopupOrder', JSON.stringify({
          bookingTerms: this.bookingTerms,
          cancellationTerms: this.cancellationTerms,
          time: this.time,
          status: this.status,
          tariffs,
          smRegistered: this.smRegistered,
          agency: {
            fullName: this.agency?.legal_information?.fullName,
            inn: this.agency?.legal_information?.inn,
            ogrn: this.agency?.legal_information?.ogrn,
            sm_registered: this.agency?.sm_registered,
          },
          entity: this.entity,
          date: this.currentDay,
          title: this.entityTitle,
          id: this.id,
        }), {
          path: '/',
          maxAge: 60 * 60 * 24 * 7
        })
        this.$login()
      }
    },
  }
}
